import { ArrayInput, Edit, SimpleForm, SimpleFormIterator } from "react-admin";
import { useNotification } from "../../../../common/hooks/useNotification";
import { EditActions } from "../../../common/form/FormActions";
import { EldFileForImport } from "./EldFileForImport";

export const EldImportFinish = (props: any) => {
  const notify = useNotification(props, "importSuccess");

  return (
    <Edit
      {...props}
      actions={<EditActions />}
      onSuccess={notify}
      title="resources.admin-eld-import.title.import"
      transform={(data) => {
        console.log("Submitting data", data);
        return data;
      }}
    >
      <EldImportFinishForm />
    </Edit>
  );
};

const EldImportFinishForm = (props: any) => {
  return (
    <SimpleForm className="form-create-edit" variant="outlined" {...props}>
      <ArrayInput source="eldFiles">
        <SimpleFormIterator disableAdd disableRemove disableReordering>
          <EldFileForImport />
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  );
};
